<template>
  <div>
    <Banner :datum="banner" />
    <Introduction :datum="introduction" />
    <ImportantDates :datum="importantDate" />
    <CallForPaper :datum="callForPaper" />
    <Organization :datum="organization" />
    <Submission :datum="submission" />
    <!-- <Keynote :datum="keynote" /> -->
    <Program :datum="program" />
  </div>
</template>

<script>
import _ from "lodash";

import Banner from "@/components/Banner";
import BasicSection from "@/components/BasicSection";
import Introduction from "@/components/Introduction";
import ImportantDates from "@/components/ImportantDates";
import CallForPaper from "@/components/CallForPaper";
import Organization from "@/components/Organization";
import Submission from "@/components/Submission";
import Keynote from "@/components/Keynote";
import Program from "@/components/Program";

import db from "@/db.yml";
console.log(db);

export default {
  name: "Home",
  components: {
    Banner,
    BasicSection,
    Introduction,
    ImportantDates,
    CallForPaper,
    Organization,
    Submission,
    Keynote,
    Program
  },
  data() {
    const PLACEHOLD = "$YEAR$";

    function replacePlacehold(x, year) {
      return x.split(PLACEHOLD).join(year);
    }

    const year = parseInt(this.$route.params.year);

    let session = _.find(db.sessions, x => x.meta.year === year);
    console.log(session);
    let data = {};
    if (session.meta.useDefault) {
      data = _.assign({}, db.default, session);
      let paragraphsToReplace = ["introduction", "submission"];
      for (const k of paragraphsToReplace) {
        data[k].paragraphs = _.map(data[k].paragraphs, x =>
          replacePlacehold(x, year)
        );
      }
      let submissionPageUrlsToReplace = ["callForPaper", "submission"];
      for (const k of submissionPageUrlsToReplace) {
        data[k].submissionPageUrl = replacePlacehold(
          data[k].submissionPageUrl,
          year
        );
      }
    } else {
      data = session;
    }

    console.log(data);
    return {
      ...data,
      banner: { meta: data.meta, ...data.banner }
    };
  },

  mounted() {
    document.title = `IBF ${this.meta.year} ${this.meta.location}`;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue